import { useCurrentUserContext } from '@/modules/auth/hooks/useCurrentUserContext';
import { useExportPaymentGroups } from '@/modules/payments/hooks/useExportPaymentGroups';
import { useExportPayments } from '@/modules/payments/hooks/useExportPayments';
import { PaymentStatus, PaymentType } from '@/types/payment';
import { PaymentGroupType } from '@/types/payment-groups';
import { UserRole } from '@/types/user';
import { ColumnFiltersState } from '@tanstack/react-table';
import { PaymentPageStage } from '../types';

export function usePaymentsExport(
  columnFilters: ColumnFiltersState,
  stage?: PaymentPageStage,
) {
  const { currentUser, taxBenefitsProvider } = useCurrentUserContext() ?? {};

  const { exportPayments, isExporting: isExportingPayments } =
    useExportPayments(
      currentUser?.roles.includes(UserRole.TaxBenefitsProvider)
        ? taxBenefitsProvider?._id
        : undefined,
      columnFilters.find(filter => filter.id === 'type')?.value as
        | PaymentType
        | undefined,
    );

  const { exportPaymentGroups, isExporting: isExportingPaymentGroups } =
    useExportPaymentGroups({
      status: columnFilters.find(filter => filter.id === 'status')?.value as
        | PaymentStatus[]
        | undefined,
      ...(columnFilters.find(filter => filter.id === 'status')?.value
        ? {}
        : { stage: stage }),
      ...((columnFilters.find(filter => filter.id === 'paymentGroupType')
        ?.value as PaymentGroupType | undefined) && {
        type: columnFilters.find(filter => filter.id === 'paymentGroupType')
          ?.value as PaymentGroupType | undefined,
      }),
    });

  return {
    exportPayments,
    exportPaymentGroups,
    isExportingPayments,
    isExportingPaymentGroups,
  };
}
